import script from "./sendConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./sendConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./sendConfirmDialog.vue?vue&type=style&index=0&id=4f2421ee&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2421ee"]])

export default __exports__